import { render, staticRenderFns } from "./realEstateChannels.vue?vue&type=template&id=6dc66bb3&"
import script from "./realEstateChannels.vue?vue&type=script&lang=js&"
export * from "./realEstateChannels.vue?vue&type=script&lang=js&"
import style0 from "./realEstateChannels.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports